export const CROSS_PRODUCT_PRODUCT_ID = 'cross-product';
